// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2026-01-17 16:54:32 +0100 (Sat, 17 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 159862 $
//  Purpose   : fulltext parts
// =============================================================================
import React from 'react'

import {loadLazy as ll} from 'uix/parts'

export const TreeSearchFulltext = ll(() => import(/* webpackChunkName: 'search' */ './treesearch'))
export const SearchResult = ll(() => import(/* webpackChunkName: 'search' */ './searchres'))
export const TreeSearchSemantic = ll(() => import(/* webpackChunkName: 'search' */ './semsearch'))

export const IndexDetails = ll(() => import(/* webpackChunkName: 'search' */ './indexdetails'))
export const IndexOps = ll(() => import(/* webpackChunkName: 'search' */ './indexops'))
